import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import React from 'react'
import styled from 'styled-components'

const Button = styled.button`
  padding: 0.25rem;

  &:hover {
    background: ${({ theme }) => theme.forecast.background4};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

interface ScrollButtonProps {
  direction: 'left' | 'right'
  onClick: () => void
}

export const ScrollButton: React.FC<ScrollButtonProps> = ({
  direction,
  onClick,
}) => {
  return (
    <Button onClick={onClick}>
      {direction === 'left' ? (
        <ChevronLeftIcon width={16} height={16} />
      ) : (
        <ChevronRightIcon width={16} height={16} />
      )}
    </Button>
  )
}
